import { api } from "@/api/client";

export const LAYOUT_NOTIFICACAO_PATH = "notificacao/WS/LayoutNotificacao";
export const ROLE_PATH = "notificacao/Role";

export interface LayoutNotificacaoRegistro {
  id?: number;
  gatilho: string;
  descricao: string;
  // Nunca teve validação no legado (ver D14 em docs/migracao/decisoes.md);
  // registros antigos podem não ter esses valores gravados.
  seInterno?: "S" | "N" | null;
  seExibir?: "S" | "N" | null;
  sePortal?: "S" | "N" | null;
  seEmail?: "S" | "N" | null;
  sePush?: "S" | "N" | null;
  tituloPortal?: string;
  corpoPortal?: string;
  tituloNavegador?: string;
  corpoNavegador?: string;
  urlWeb?: string;
  tituloPush?: string;
  corpoPush?: string;
  urlApp?: string;
  assuntoEmail?: string;
  emailRemetente?: string;
  corpoEmail?: string;
  idTemplate?: string;
  documentacao?: string;
}

export interface Role {
  nome: string;
  descricao: string;
}

export interface LayoutNotificacaoDto {
  layoutNotificacao: LayoutNotificacaoRegistro;
  roles: Role[];
}

// Linha da listagem (ConsultaLayoutNotificacao) — subconjunto do que
// /Dto/{id} devolve por completo (LayoutNotificacaoRegistro).
export interface LayoutNotificacao {
  id: number;
  gatilho: string;
  descricao: string;
  situacao: "A" | "I" | string;
}

export interface LayoutNotificacaoFiltro {
  descricao?: string;
}

export async function getRoles(): Promise<Role[]> {
  const { data } = await api.get<Role[]>(`${ROLE_PATH}/`);
  return data;
}

export async function getLayoutNotificacaoDto(id: number): Promise<LayoutNotificacaoDto> {
  const { data } = await api.get<LayoutNotificacaoDto>(`${LAYOUT_NOTIFICACAO_PATH}/Dto/${id}`);
  return data;
}

export async function saveLayoutNotificacaoDto(dto: LayoutNotificacaoDto): Promise<void> {
  await api.post(`${LAYOUT_NOTIFICACAO_PATH}/Dto`, dto);
}

export async function deleteLayoutNotificacao(id: number): Promise<void> {
  await api.delete(`${LAYOUT_NOTIFICACAO_PATH}/${id}`);
}
